import { Box, Text } from '@chakra-ui/layout';
import { type MouseEventHandler, type ReactNode, useEffect } from 'react';

import {
  type ChartError,
  useReportChartError,
} from '../AIBuilder/ChartErrorContext';

const MESSAGE = 'No data available for selected metrics or filters';

interface ChartNotSupportedProps {
  children?: ReactNode;
  /** Error details for AI auto-fix reporting */
  errorDetails?: Omit<ChartError, 'timestamp'>;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const ChartNotSupported = ({
  children,
  errorDetails,
  onClick,
}: ChartNotSupportedProps) => {
  const reportError = useReportChartError();

  // Report error to context when mounted with error details
  useEffect(() => {
    if (errorDetails) {
      reportError(errorDetails);
    }
  }, [errorDetails, reportError]);

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      onClick={onClick}
    >
      <Text textAlign="center">{children || MESSAGE}</Text>
    </Box>
  );
};
